const LOAD_PRODUCTS = 'header/LOAD_PRODUCTS';
const ADD_PRODUCT = 'header/ADD_PRODUCT';
const CLEAR_PRODUCTS = 'header/CLEAR_PRODUCTS';
const LOAD_USERMENU = 'header/LOAD_USERMENU';

const initialState = {
  products: [],
  userMenu: []
};

export const loadProducts = p => ({ type: LOAD_PRODUCTS, products: p });
export const addProduct = p => ({ type: ADD_PRODUCT, product: p });
export const loadUserMenu = m => ({ type: LOAD_USERMENU, menu: m });
export const clearProducts = () => ({ type: CLEAR_PRODUCTS });

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, products: action.products };

    case LOAD_USERMENU:
      return { ...state, userMenu: action.menu };

    case CLEAR_PRODUCTS:
      return { ...state, products: initialState.products };

    case ADD_PRODUCT: {
      const xists = state.products.find(p => p.url === action.product.url);
      if (!xists) {
        return {
          ...state,
          products: [...state.products, { ...action.product, id: state.products.length }]
        };
      }
      return state;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Header/ducks.js